import { daysInYear, format, min } from 'date-fns';
import React, { useEffect, useState } from 'react';

const TimePicker = ({ selectedDay, selectedMonth, selectedYear, selectedHour, selectedMinute, hours, minutes, openingTimes, schedule, onChange, occasionTitle }) => {

    const getDayNumber = () => {
        var selectedDate = new Date(selectedYear, selectedMonth, selectedDay);
        return selectedDate.getDay()
    }

    const isNow = (year, month, day, hour = 0) => {
        var now = new Date();
        if (now.getFullYear() == year && now.getMonth() == month && now.getDate() == day) {
            if (hour === 0) {
                return true;
            }
            else {
                if (now.getHours() == hour) {
                    return true;
                }
            }
        }

        return false;

    }
/*
    const getMinutes = () => {
        let minutes = [];
        if (timeInfo.selectedOpeningTimeString) {
            var openTimes = timeInfo.selectedOpeningTimeString.split("T")[1].replace(":00Z", "").split(":");
            var openingHour = parseInt(openTimes[0]);
            var openingMinute = parseInt(openTimes[1]);
            var closingTimes = timeInfo.selectedClosingTimeString.split("T")[1].replace(":00Z", "").split(":");
            var closingHour = parseInt(closingTimes[0]);
            var closingMinute = parseInt(closingTimes[1]);

            if (selectedHour === openingHour.toString()) {
                for (let i = openingMinute; i <= 45; i += 15) {
                    minutes.push(i.toString().padStart(2, "0"))
                }
            }
            else if (selectedHour === (closingHour).toString()) {
                for (let i = 0; i <= closingMinute; i += 15) {
                    minutes.push(i.toString().padStart(2, "0"))
                }
            }
            else if (isNow(selectedYear, selectedMonth, selectedDay, selectedHour)) {
                for (let i = Math.ceil(new Date().getMinutes() / 15) * 15; i <= 45; i += 15) {
                    minutes.push(i.toString().padStart(2, "0"))
                }
                if (!minutes.length) {
                    minutes.push("00");
                }
            }
            else {
                for (let i = 0; i <= 45; i += 15) {
                    minutes.push(i.toString().padStart(2, "0"))
                }
            }

        }

        return minutes;
    }*/

    const handleHourChange = (e) => {
        onChange(e.target.value, isMinutesOutsideSchedule(selectedMinute) ? '00' : selectedMinute);
    }

    const handleMinuteChange = (e) => {
        onChange(selectedHour, e.target.value);
    }

    const isHourEnabled = (h) => {
        if (!schedule) return true;

        //var schedule = schedule[]

        var date = new Date(selectedYear, selectedMonth, selectedDay);
        var dateKey = format(date, 'yyyy-MM-dd');
        var daySchedule = schedule[dateKey];
        if (daySchedule) {
            return !!daySchedule.timeSlots.find(ts => ts.startsWith(h + ':'));
        }
    }

    const isMinutesOutsideSchedule = (m) => {
        if (!schedule) return true;
        var date = new Date(selectedYear, selectedMonth, selectedDay);
        var dateKey = format(date, 'yyyy-MM-dd');
        var daySchedule = schedule[dateKey];
        var firstScheduledTimeSlot = daySchedule.timeSlots[0]
        var lastScheduledTimeSlot = daySchedule.timeSlots[daySchedule.timeSlots.length - 1]
        if (daySchedule) {
            return selectedHour + ':' + m <= lastScheduledTimeSlot && selectedHour + ':' + m >= firstScheduledTimeSlot;
        }
    }

    return (
        <React.Fragment>
            <label className='label'>Preferred time *</label>
            <div className="timeslot-simple-dropdown">
                <div className='grid grid-flow-col gap-4'>
                    <div>
                        <select value={selectedHour} className='select time-select w-full' onChange={handleHourChange}>
                            {hours.map(h => {
                                if ((isHourEnabled(h)))
                                    return (<option key={"hour" + h}>{h}</option>)
                                else
                                    return (<option disabled key={"hour" + h} value="">{h} - {occasionTitle} Not Available</option>)
                            }

                            )}
                        </select>
                    </div>
                    <div>
                        <select value={selectedMinute} className='select time-select w-full' onChange={handleMinuteChange}>
                            {minutes.map(m => {
                                if (isMinutesOutsideSchedule(m)) {
                                    return <option key={"minute" + m}>{m}</option>
                                } else {
                                    return <option disabled value="" key={"minute" + m}>{m}</option>
                                }
                            }
                        )}

                        </select>
                    </div>
                </div>
            </div>
            <p className='field-info'>We'll check availability on the next stage</p>
        </React.Fragment>
    );

}

export default TimePicker;